"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTR_TENANT_PK = exports.routerPathGroup = exports.apiPathGroup = exports.packageGroup = exports.subjectName = void 0;
exports.subjectName = 'Tenant';
exports.packageGroup = 'tenant';
exports.apiPathGroup = 'tenants';
exports.routerPathGroup = 'tenant';
exports.ATTR_TENANT_PK = 'tenant-pk';
